import { render, staticRenderFns } from "./ModalEditStock.vue?vue&type=template&id=295482a8&scoped=true"
import script from "./ModalEditStock.vue?vue&type=script&lang=js"
export * from "./ModalEditStock.vue?vue&type=script&lang=js"
import style0 from "./ModalEditStock.vue?vue&type=style&index=0&id=295482a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295482a8",
  null
  
)

export default component.exports